var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 511",
    style: {
      enableBackground: "new 0 0 511 511"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511,144h-64V96h-32V56H96v40H64v48H0v239h96v72h319v-72h96V144z M432,111v33h-17v-33H432z M400,71v73H111V71H400z M79,111 h17v33H79V111z M496,159v177h-81v-49h24.5v-15h-368v15H96v49H15V159H496z M15,368v-17h81v17H15z M111,440V287h289v153H111z  M415,368v-17h81v17H415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,247c17.369,0,31.5-14.131,31.5-31.5S120.869,184,103.5,184S72,198.131,72,215.5S86.131,247,103.5,247z M103.5,199 c9.098,0,16.5,7.402,16.5,16.5s-7.402,16.5-16.5,16.5S87,224.598,87,215.5S94.402,199,103.5,199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,239c12.958,0,23.5-10.542,23.5-23.5S188.458,192,175.5,192S152,202.542,152,215.5S162.542,239,175.5,239z  M175.5,207c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S170.813,207,175.5,207z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 312,
    width: 96,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.5,
    y: 312,
    width: 112,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 392,
    width: 88,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 392,
    width: 120,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.5,
    y: 352,
    width: 48,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.5,
    y: 352,
    width: 160,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.5,
    y: 208,
    width: 88,
    height: 15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.ebf78e4e1610b000875f1ffdc9f62189.svg";
export { ForwardRef as ReactComponent };